/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { sva } from "@panda/css";

export const newsCard = sva({
	slots: ["wrapper", "overlay", "image-box", "image", "meta"],
	base: {
		wrapper: {
			"&&": {
				display: "flex",
				gap: "eds.dimension.12",
				minHeight: "172px",
				flexGrow: "1",
				mdDown: {
					minHeight: "153px",
				},
				xsDown: {
					flexDirection: "column",
				},
			},

			"&:hover": {
				"& .image": {
					transform: "scale(1.05)",
				},
			},
			"& .cosmos-text.cosmos-title": {
				lineClamp: "2",
				overflow: "hidden",
				mdDown: {
					lineClamp: "1",
				},
				"& p": {
					margin: 0,
				},
			},
			"& .cosmos-text.cosmos-desc": {
				lineClamp: "2",
				overflow: "hidden",
			},
			_chrome142: {
				backdropFilter: "none!",
			},
			"& .news-card-content": {
				xs: {
					flexBasis: "55%",
				},
			},
		},
		"image-box": {
			aspectRatio: "16/9",
			width: "263px",
			maxWidth: "263px",
			flexShrink: 0,
			flexGrow: 0,
			height: "auto",
			minH: "full",
			xsToMd: {
				aspectRatio: "unset!important",
			},
			smOnly: {
				width: "229px",
				maxWidth: "229px",
			},
			xsOnly: {
				minHeight: "eds.dimension.128",
			},
			xs: {
				flexBasis: "45%",
			},
			xsDown: {
				aspectRatio: "16/9!important",
				width: "full",
				maxWidth: "full",
			},
		},
		image: {
			transition: "transform token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)",
			height: "100%",
			width: "100%",
			objectFit: "cover",
		},
	},
});
